import { ChangeDetectorRef, Component, ViewChild, ViewContainerRef } from "@angular/core";
import dynamicFormPoc from "./dynamic-form-poc.json";
import { DynamicFormService } from "../../services/dynamic-form.service";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { DynamicFormComponent } from "../dynamic-form/dynamic-form.component";
import { DynamicForm } from "../../models/dynamic-form";
import { AccordionTableComponent } from "../accordion-table/accordion-table.component";
import { LoginHistoryComponent } from "../login-history/login-history.component";
import { TableHeaderAndData } from "../../models/table-header-and-data";
import { SelectComponent } from "../select/select.component";
import { LoginComponent } from "../login/login.component";
import { NoDataComponent } from "../no-data/no-data.component";
import { EditableTableComponent } from "../editable-table/editable-table.component";
import { ManageItemFilingComponent } from "../operations/item-filing/manage-item-filing/manage-item-filing.component";
import { InputComponent } from "../input/input.component";
import { FileUploadDialogComponent } from "../operations/igm-desk/file-upload-dialog/file-upload-dialog.component";
import { TosTableComponent } from "../tos-table/tos-table.component";
import { ModalComponent } from "../modal/modal.component";
import { AdvancedFilterComponentV2 } from "../advanced-filter/advanced-filter-v2.component";
import { AdvancedFilterComponent } from "../advanced-filter/advanced-filter.component";
import filterConfig from "./filter-poc.json";
import { TariffTable } from "../finance/tariff/tariff-table/tariff-table";
import { InvoiceComponent } from "../finance/invoice/invoice.component";
import { AutocompleteDropdownComponent } from "../autocomplete-dropdown/autocomplete-dropdown.component";
import { DatePickerComponent } from "../common/date-picker/date-picker.component";
import { TariffOverviewComponent } from "../finance/invoice/tariff-overview/tariff-overview.component";

@Component({
  selector: "app-dynamic-form-poc",
  standalone: true,
  imports: [
    DynamicFormComponent,
    AccordionTableComponent,
    TosTableComponent,
    ModalComponent,
    AdvancedFilterComponentV2,
    TosTableComponent,
    TariffTable,
    InvoiceComponent,
    AutocompleteDropdownComponent,
    ReactiveFormsModule,
    DatePickerComponent,
    TariffOverviewComponent
  ],
  templateUrl: "./dynamic-form-poc.component.html",
  styleUrl: "./dynamic-form-poc.component.scss"
})
export class DynamicFormPocComponent {

}
